import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'pxw-icon[icon="billing-voucher"]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../icon/icon.component.scss'],
  providers: [{ provide: IconComponent, useExisting: IconBillingVoucherComponent }],
  template: `
    <svg viewBox="0 0 45 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4.03999H42V7.82485H38.2V42.04L35.1125 39.5798L31.6146 36.7942L28.5366 39.5193L27.275 40.6358L26.0134 39.5193L23 36.8491L19.9866 39.5174L18.725 40.6339L17.4634 39.5174L14.3854 36.7923L10.8875 39.5798L7.8 42.04V7.82485H4V4.03999ZM11.6 7.82485V34.1675L13.2625 32.8428L14.5146 31.8436L15.7116 32.9033L18.725 35.5717L21.7384 32.9033L23 31.7868L24.2616 32.9033L27.275 35.5717L30.2884 32.9033L31.4854 31.8436L32.7375 32.8409L34.4 34.1656V7.82485H11.6ZM15.4 13.5021H30.6V17.287H15.4V13.5021ZM19.2 21.0719H17.3V24.8567H28.7V21.0719H19.2Z"
      />
    </svg>
  `,
})
export class IconBillingVoucherComponent extends IconComponent {}
